import client from "../../../api/client";

export default async function updateRoomListingImages(
  listingId,
  {
    images = [],
    deleteImageIds = [],
    primaryImageId = "",
    replaceAll = false,
  } = {}
) {
  const formData = new FormData();

  if (Array.isArray(images) && images.length > 0) {
    images.forEach((file) => {
      if (file) {
        formData.append("images[]", file);
      }
    });
  }

  if (Array.isArray(deleteImageIds) && deleteImageIds.length > 0) {
    deleteImageIds.forEach((id) => {
      if (id !== undefined && id !== null && String(id).trim() !== "") {
        formData.append("delete_image_ids[]", String(id));
      }
    });
  }

  if (
    primaryImageId !== undefined &&
    primaryImageId !== null &&
    String(primaryImageId).trim() !== ""
  ) {
    formData.append("primary_image_id", String(primaryImageId));
  }

  formData.append("replace_all", replaceAll ? "true" : "false");

  const response = await client.post(
    `/room-listings/${listingId}/images/update`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response?.data;
}